<template src="./index.html" />
<script>
import { validationMixin } from 'vuelidate';
import {
  required,
  sameAs,
  minLength,
} from 'vuelidate/lib/validators';
import { Auth } from 'aws-amplify';
/* eslint-disable vue/require-prop-types */
export default {
  name: 'CompleteNewPassword',
  mixins: [validationMixin],
  props: ['user'],
  data: () => ({
    errorWithCode: null,
    showNewPassword: false,
    showConfirmPassword: false,
    password: {
      newPassword: null,
      repeatPassword: null,
    },
  }),
  validations: {
    password: {
      newPassword: {
        required, minLength: minLength(8),
      },
      repeatPassword: {
        required, sameAs: sameAs('newPassword'),
      },
    },
  },
  computed: {
    newPasswordErrors() {
      const errors = [];
      if (!this.$v.password.newPassword.$dirty) return errors;
      if (!this.$v.password.newPassword.required) {
        errors.push('Please enter required value');
      }
      if (!this.$v.password.newPassword.minLength) {
        errors.push('Password must be with 8 characters long');
      }
      return errors;
    },
    repeatPasswordErrors() {
      const errors = [];
      if (!this.$v.password.repeatPassword.$dirty) return errors;
      if (!this.$v.password.repeatPassword.required) {
        errors.push('Please enter required value');
      }
      if (!this.$v.password.repeatPassword.sameAs) {
        errors.push('Confirm Password must be the same');
      }
      return errors;
    },
  },
  created() {
    if (!this.user) {
      this.$router.push('login');
    }
  },
  methods: {
    async confirmResetPassword() {
      this.$v.password.$touch();
      if (!this.$v.password.$invalid) {
        this.$store.commit('spinner', true);
        try {
          await Auth.completeNewPassword(
            this.user,
            this.password.newPassword,
            this.user.challengeParam.requiredAttributes,
          );
          this.$router.push({
            path: 'users/all',
          });
        } catch (err) {
          console.log('err', err);
          this.$store.commit('spinner', false);
        }
      }
    },
  },
};
</script>
<style scoped lang="scss" src="./index.scss"></style>
